<template>
  <main class="main">
    <div class="hero-section-container">
      <img src="../img/hero.webp" class="bg" />
      <div class="section hero-section">
        <div class="wrapper">
          <div :class="['title', { active: $parent.heroImagesLoaded }]">
            RUST LEGACY REVIVED!
          </div>
          <div :class="['desc', { active: $parent.heroImagesLoaded }]">
            Discover expert guides, relive the classic era, connect with the
            nostalgic community, and grab exclusive blueprints & mods. Dive in
            and conquer the original Rust world with us!
          </div>
          <div
            :class="['ip-container', { active: $parent.heroImagesLoaded }]"
            v-if="$parent.ip && $parent.port"
          >
            <img src="../img/cornersBig/top-left-corner.svg" class="top-left" />
            <img
              src="../img/cornersBig/top-right-corner.svg"
              class="top-right"
            />
            <img
              src="../img/cornersBig/bottom-left-corner.svg"
              class="bottom-left"
            />
            <img
              src="../img/cornersBig/bottom-right-corner.svg"
              class="bottom-right"
            />
            <div class="desc">
              <b> {{ $parent.ip + ":" + $parent.port }}</b>
            </div>
            <button
              class="button black"
              v-clipboard="$parent.ip + ':' + $parent.port"
              v-clipboard:success="clipboardSuccessHandler"
            >
              <img src="../img/copy.svg" class="img" />
              <span>{{ copied ? "COPIED" : "COPY" }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="section how-section" id="how">
      <div class="wrapper">
        <div class="title">HOW IT WORKS</div>

        <img src="../img/how.webp" class="how" />
        <div class="list">
          <div class="item">
            <div class="item-wrapper">
              <img src="../img/corners2/top-left-corner.svg" class="top-left" />
              <img
                src="../img/corners2/top-right-corner.svg"
                class="top-right"
              />
              <img
                src="../img/corners2/bottom-left-corner.svg"
                class="bottom-left"
              />
              <img
                src="../img/corners2/bottom-right-corner.svg"
                class="bottom-right"
              />
              <img src="../img/how/1.svg" class="img" />
              <div class="desc desc1">
                Purchase Rust on Steam (official license required to access our
                server). Then download and set up the Rust Legacy client.
              </div>
              <div class="desc desc2">
                Purchase Rust on Steam (official license required to access our
                server). Then download and set up the Rust Legacy client.
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-wrapper">
              <img src="../img/corners2/top-left-corner.svg" class="top-left" />
              <img
                src="../img/corners2/top-right-corner.svg"
                class="top-right"
              />
              <img
                src="../img/corners2/bottom-left-corner.svg"
                class="bottom-left"
              />
              <img
                src="../img/corners2/bottom-right-corner.svg"
                class="bottom-right"
              />
              <img src="../img/how/2.svg" class="img" />
              <div class="desc desc1">
                Launch the game and open console press F1 to open the console.
                Copy & Paste IP Type client.connect "number ip address" and hit
                Enter.
              </div>
              <div class="desc desc2">
                Launch the game and open console press F1 to open the console.
                Copy & Paste IP Type client.connect "number ip address" and hit
                Enter.
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-wrapper">
              <img src="../img/corners2/top-left-corner.svg" class="top-left" />
              <img
                src="../img/corners2/top-right-corner.svg"
                class="top-right"
              />
              <img
                src="../img/corners2/bottom-left-corner.svg"
                class="bottom-left"
              />
              <img
                src="../img/corners2/bottom-right-corner.svg"
                class="bottom-right"
              />
              <img src="../img/how/3.svg" class="img" />
              <div class="desc desc1">
                That's it! Start playing now You'll spawn in — build, raid,
                survive on RustLegacyS server! If you'd like to buy in-game
                items , check out our store.
              </div>
              <div class="desc desc2">
                That's it! Start playing now You'll spawn in — build, raid,
                survive on RustLegacyS server! If you'd like to buy in-game
                items , check out our store.
              </div>
            </div>
          </div>
        </div>
        <router-link to="/products" class="button"> SHOP </router-link>
      </div>
    </div>

    <div class="section features-section">
      <div class="wrapper">
        <img src="../img/features/cog.webp" class="cog1" />
        <img src="../img/features/cog.webp" class="cog2" />
        <img src="../img/features/cog.webp" class="cog3" />
        <img src="../img/features/cog.webp" class="cog4" />
        <div class="list">
          <div class="item">
            <div class="desc big">
              <b>CUSTOM LEGACY MAPS</b>
            </div>
          </div>
          <div class="item">
            <div class="desc big">
              <b>SPECIAL EVENTS</b>
            </div>
          </div>
          <div class="item">
            <div class="desc big">
              <b>UNIQUE REWARDS</b>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section faq-section" id="faq" ref="faqSection">
      <img src="./../img/faq/cloud1.webp" class="cloud1" />
      <img src="./../img/faq/cloud2.webp" class="cloud2" />
      <img src="./../img/faq/cloud3.webp" class="cloud3" />
      <div class="wrapper">
        <div class="title title-70">
          <b>FAQ</b>
        </div>
        <div class="accordion">
          <div
            :class="['item', { active: isActivePanel(index) }]"
            v-for="(item, index) in $parent.faq"
            :key="index"
          >
            <div class="panel" @click="togglePanel(index)">
              <img src="./../img/faq/plus.svg" class="plus" />
              <img src="./../img/faq/minus.svg" class="minus" />
              <div class="desc question">
                <b>{{ item.question }}</b>
              </div>
            </div>
            <div class="desc answer" v-if="isActivePanel(index)">
              {{ item.answer }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section rules-section">
      <div class="wrapper">
        <img src="../img/rulesImg.webp" class="img" />
        <div class="text">
          <div class="title title-70">SERVER RULES</div>
          <div class="desc">RustLegacyS — Play Fair, Play Classic</div>
          <div class="list">
            <div class="item">
              <div class="desc medium">
                <b
                  >◦ Treat all players with respect and kindness. No toxicity,
                  racism, harassment, or spam.</b
                >
              </div>
            </div>
            <div class="item">
              <div class="desc medium">
                <b
                  >◦ No cheats, hacks, exploits, or macros. Clean gameplay only
                  — instant ban for violations.</b
                >
              </div>
            </div>
            <div class="item">
              <div class="desc medium">
                <b
                  >◦ Do not share personal info. Keep real names, addresses, or
                  private data out of chat.</b
                >
              </div>
            </div>
          </div>
          <div class="desc">
            <span class="yellow">
              Violation? Report via support@rustlegacys.com
            </span>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Vue from "vue";
import Clipboard from "v-clipboard";
Vue.use(Clipboard);

export default {
  name: "Home",
  props: ["currency", "currencyCode"],
  components: {},
  data: function () {
    return {
      activePanels: [],
      copied: false,
      isMoving: false,
      startPosition: 0,
      isMoving2: false,
      startPosition2: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const section = this.$refs.targetSection;
      const movableElement = this.$refs.movableElement;
      const movableElement2 = this.$refs.movableElement2;

      if (section && movableElement && movableElement2) {
        const rect = section.getBoundingClientRect();

        // Check if the section's top is at the top of the viewport
        if (rect.top <= 200 && rect.bottom > 0 && !this.isMoving) {
          this.isMoving = true;
          this.startPosition = window.scrollY;
        }

        // Move the element if the section is in view
        if (this.isMoving) {
          const scrollOffset = window.scrollY - this.startPosition;
          movableElement.style.transform = `translateX(-${scrollOffset}px) translateY(${scrollOffset}px)`;
          movableElement2.style.transform = `translateX(+${scrollOffset}px) translateY(${scrollOffset}px)`;
        }
      }

      const faqSection = this.$refs.faqSection;
      const cloud1 = this.$refs.cloud1;
      const cloud2 = this.$refs.cloud2;

      if (faqSection && cloud1 && cloud2) {
        const rect2 = faqSection.getBoundingClientRect();

        if (rect2.top <= 400 && rect2.bottom > 0 && !this.isMoving2) {
          this.isMoving2 = true;
          this.startPosition2 = window.scrollY;
        }

        // Move the element if the section is in view
        if (this.isMoving2) {
          const scrollOffset = window.scrollY - this.startPosition2;
          cloud1.style.transform = `translateX(calc(-50% - (-${scrollOffset}px + 1260px))) translateY(calc(-50% - 90px))`;
          cloud2.style.transform = `translateX(calc(-50% + (-${scrollOffset}px + 1260px))) translateY(calc(-50% - 30px))`;
        }
      }
    },
    clipboardSuccessHandler() {
      let self = this;
      self.copied = true;
      setTimeout(() => {
        self.copied = false;
      }, 1200);
    },
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1);
      } else {
        this.activePanels.push(index);
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index);
    },
  },
};
</script>
